// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l08jY","comment":"styles_comment__3ap8c"};